 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0,
 		69: 0,
 		70: 0,
 		80: 0,
 		124: 0,
 		125: 0,
 		132: 0,
 		133: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","6":"AddClosedAlertIDUseCase","7":"CreateDeviceUseCase","8":"CreateDomestikaFollowUseCase","9":"CreateJWTUserUseCase","10":"CreateUserLiveSessionUseCase","11":"CurrentUserUseCase","12":"CurrentWithoutRelationshipsUserUseCase","13":"DeleteDeviceUseCase","14":"DeleteFollowUseCase","15":"ENV_CONFIG1","16":"ENV_CONFIG4","17":"ENV_CONFIG5","18":"ENV_CONFIG6","19":"ENV_CONFIG7","20":"FinishUserLiveSessionUseCase","21":"GetAccessTokenUserUseCase","22":"GetAdvanceGDPRStatusUserUseCase","23":"GetAllBlogUseCase","24":"GetAreasCourseUseCase","25":"GetCartCourseUseCase","26":"GetCategoriesCourseUseCase","27":"GetCourseUseCase","28":"GetFinalProjectVideoByCourseIDCourseUseCase","29":"GetGDPRStatusUserUseCase","30":"GetListLiveFeedbackQuestionUseCase","31":"GetListLiveSessionUseCase","32":"GetListLiveStreamUseCase","33":"GetLiveChannelUseCase","34":"GetLiveSessionUseCase","35":"GetOrganizationUseCase","36":"GetPlusPromotionUseCase","37":"GetPostContentBlogUseCase","38":"GetPromotionCodeAlertUseCase","39":"GetPromotionUseCase","40":"GetPubnubCredentialsUseCase","41":"GetSessionDataUserUseCase","42":"GetSimpleUserUseCase","43":"GetSoftwaresCourseUseCase","44":"GetUserAlertUseCase","45":"GetVideoProgressListCourseUseCase","46":"GetVideoSpeedUserUseCase","47":"GetVideoVolumeUserUseCase","48":"LogoutUserUseCase","49":"PathToRegexp","50":"RefreshAccessTokenUserUseCase","51":"RemoveAccessTokenUserUseCase","52":"SearchCourseUseCase","53":"SendHeaderTrackingUseCase","54":"SendLiveFeedbackAnswersUseCase","55":"SendPlayerTrackingUseCase","56":"SendTrackingUseCase","57":"SendVideoProgressCourseUseCase","58":"SetAdvanceGDPRStatusUserUseCase","59":"SetGDPRStatusUserUseCase","60":"SetVideoSpeedUserUseCase","61":"SetVideoVolumeUserUseCase","62":"UpdateLanguageUserUseCase","63":"UpdateLiveSessionUseCase","64":"UpdateVideoAudioAndSubtitlesCourseUseCase","65":"UpdateVideoProgressCourseUseCase","66":"ViewPageTrackingUseCase","134":"vendors~AddClosedAlertIDUseCase","135":"vendors~AlgoliaSearch","136":"vendors~AmplitudeJS","137":"vendors~SearchCourseUseCase","138":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"5861f09ef3addc964c90","1":"d572d8cd2bc47c328bb1","2":"61b91a5bbb627b2c777c","3":"c976a1e45652572ea96e","4":"1c8fa80aea316525878e","5":"7eecdedee3270ac7714c","6":"14126d6a654b81c2c39e","7":"fc0f6ccc45b97ebef0f9","8":"a0498a1580a01d0628db","9":"2cd9e90650f5210cd0b4","10":"26162e048cbc21d655aa","11":"cbaaae351ded6efe265f","12":"36f822215a5a5b2415ca","13":"8fcad6a581e9e6b6b5c9","14":"14ccab660eaaae2d0cff","15":"b60b97eef49f4c567b12","16":"fb24333798744bd3666b","17":"41b4def027e019349c99","18":"941f751640797ccedb9e","19":"00cc55fca5e97d253f9e","20":"268b4205ffe71f39289c","21":"18ab6854d7455541f219","22":"56d0ea30c1fe1b7e7e5a","23":"3c09fadd2b0ae12c7ac9","24":"e82597deb86661e5a854","25":"09ec6cc37c2cd2b0b4d4","26":"e6efa30ef0df16f49020","27":"4301d04a5c55a3070aa6","28":"bef059c46585c95b9c6c","29":"dd169e753618be73b8f2","30":"79c7b6f6cd18af7a986b","31":"c1d8d71665a3ea29a77d","32":"c85544eb255b92e91a69","33":"3b2682c576c50fa6a58c","34":"409e05c909dc3fad0017","35":"a991a98eb283a15b4c9f","36":"976e02195d7b60087c79","37":"6b1aa99b1846ba35270b","38":"f6508e35330e8d35dce4","39":"485afad456801c1b6a50","40":"1828da02b635b6fb671f","41":"b6ad2199a1adf95f657b","42":"1a4ea55b7f2d322c721a","43":"631713c20f35206d8e20","44":"d74565f8312d6a396004","45":"99299207fb4d74d87c46","46":"846038a75675c1e2115a","47":"1d65322b3d6dd39d5fef","48":"80a95ef139d536a56f63","49":"f01bf9b7b052fe2b5b82","50":"100c5ae61425c3e508db","51":"2b15d39da7f882e9dd20","52":"0db2f6cd8247a8055654","53":"ca2f5fdd449cf69a1d1e","54":"c6a9f112c5dd451b03e1","55":"4784b589e72b6a0a8800","56":"04368bb5e4db10f6da3d","57":"08ab7f4a3e792b075c46","58":"3521ef6bbfc039e13831","59":"d2df3bfa66c5bdae6287","60":"7a6ce6c1866db4f71e02","61":"014fa00d25ae40804457","62":"68a34a653bd4a53bc2ad","63":"f399d18aa52463cb524d","64":"76fd7f7e54c45b42efcb","65":"a3b10c8ee8bf8c9a65c7","66":"c7d4fd6ff284d0156e3f","134":"90fbc7ee2a4ab90ebd07","135":"24547e01619806351e6f","136":"7a27d9fb59369fc3cdcb","137":"82f509c9504e83e6130e","138":"bc95ce05fde108c135cd","201":"0fa076bea3e7759e664e","203":"ccda723e7ed1b02c8986","204":"439e4f646761a97852d4","205":"2d27fd47040e6098e375"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 341);
